import { InjectionToken } from "@angular/core";

export const LOADER_DATA_VAR = new InjectionToken<any>("MISWebExpLoaderData");
